export const TAB_KEYCODE = 9;

export const KPL_PROVIDE_BUTTON = 'kplProvideButton';

export const POST_MESSAGE_ACTIONS = {
  SET_EXTRA_DATA: 'setExtraData',
  INVITE_LOADED: 'inviteLoaded',
  SET_FOCUS: 'setFocus',
  INVITE_SHOWN: 'inviteShown',
};

export const INVITE_ACTIONS = {
  INVITE_ACCEPTED: 'inviteAccepted',
  INVITE_DECLINED: 'inviteDeclined',
  INVITE_DEFERED: 'inviteDefered',
  INVALID_ORIGIN: 'MDigital_Invalid_Origin',
};
export const INVITE_EVENTS = {
  MESSAGE: 'message',
  ORIENTATION_CHANGE: 'orientationchange',
};
export const DEVICES_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
};

export const DEFAULT_CLOSE_BUTTON_TEXT = 'Close Survey';
export const DEFAULT_POWERED_BY_TEXT = 'Powered by';
export const DEFAULT_LANGUAGE = 'en';

export const PROVISIONS = {
  NEW_MODAL_DIALOGS: '21dcr3_MPC3281_enable_newModalDialogs',
  ALIGN_LOGO_MARKUP: '21dcr1_mpc3281_alignWCAGLogoMarkup',
  ENABLE_FORM_V2_AND_INVITE_CSS_Delay : '24dcr1_MPC7724_enableFormv2andInviteCSSDelay',
  ENABLE_INVITE_REFLOW: '25dcr2_MPC9116_enableInviteWCAGReflow',
};

export default {
  POST_MESSAGE_ACTIONS,
};
